export default "__VITE_ASSET__DOH9_Xre__"